import "core-js/modules/es.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.assign.js";
import WaitJsLoaded from '../utils/WaitJsLoaded';
import { _urlFormatter } from '../utils/utils';
var page = ['home', 'messagecenter', 'mybuy', 'publish', 'detail', 'mysell', 'order', 'person', 'village', {
  name: 'web',
  idHook: function idHook(url) {
    return _urlFormatter(url);
  }
}];

var registerMethod = function registerMethod(page) {
  return page.reduce(function (obj, method) {
    method = typeof method === 'string' ? {
      name: method
    } : method;
    var methodKey = method.name;
    var idHook = method.idHook;
    var name = methodKey.replace(/^\S/, function (s) {
      return s.toUpperCase();
    });

    obj["go".concat(name)] = function () {
      var _this = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var channelId = arguments.length > 1 ? arguments[1] : undefined;
      idHook && (id = idHook(id));

      this._invokeCB(function () {
        return _this.CallApp.start.call(_this.CallApp, {
          urlSearch: {
            'openType': methodKey,
            id: id
          },
          channelId: channelId
        });
      });
    };

    return obj;
  }, {});
};

var CallZz = /*#__PURE__*/function (_WaitJsLoaded) {
  _inherits(CallZz, _WaitJsLoaded);

  var _super = _createSuper(CallZz);

  function CallZz() {
    var _this2;

    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CallZz);

    if (option.disable) {
      _this2 = _super.call(this);
      _this2.CallApp = {
        start: function start() {
          return console.log('CallZz已禁用');
        }
      };
    } else {
      _this2 = _super.call(this, '//s1.zhuanstatic.com/common/call-app/static/js/3.2.0/index.min.js', function () {
        if (window.CallApp) {
          _this2.CallApp = new window.CallApp();
        }
      });
    }

    return _possibleConstructorReturn(_this2);
  }

  _createClass(CallZz, [{
    key: "callZz",
    value: function callZz() {
      for (var _len = arguments.length, argv = new Array(_len), _key = 0; _key < _len; _key++) {
        argv[_key] = arguments[_key];
      }

      this.CallApp.start.apply(this.CallApp, argv);
    }
  }]);

  return CallZz;
}(WaitJsLoaded);

export { CallZz as default };
Object.assign(CallZz.prototype, registerMethod(page));